"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _helpers = require("../../helpers");

var _linkButtons = require("./link-buttons.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkButtons = function LinkButtons(_ref) {
  var _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'gray800' : _ref$color,
      _ref$measure = _ref.measure,
      measure = _ref$measure === void 0 ? 'md' : _ref$measure,
      _ref$alignCenter = _ref.alignCenter,
      alignCenter = _ref$alignCenter === void 0 ? true : _ref$alignCenter,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? 20 : _ref$mt,
      _ref$isButtonFullWidt = _ref.isButtonFullWidth,
      isButtonFullWidth = _ref$isButtonFullWidt === void 0 ? false : _ref$isButtonFullWidt;
  var buttonPadding = measure === 'sm' ? 15 : 20;
  return /*#__PURE__*/_react.default.createElement(_linkButtons.WrapperStyled, {
    mt: mt,
    center: alignCenter
  }, buttons.map(function (_ref2, index) {
    var link = _ref2.link,
        type = _ref2.type,
        text = _ref2.text;
    return /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      href: link,
      color: color,
      variant: (0, _helpers.getButtonStyleByType)(type),
      as: "a",
      measure: measure,
      mt: index ? 20 : 0,
      pl: type === 'link' ? 0 : buttonPadding,
      pr: type === 'link' ? 0 : buttonPadding,
      style: {
        textAlign: 'inherit'
      },
      key: index,
      fullWidth: isButtonFullWidth && type !== 'link'
    }, text);
  }));
};

var _default = LinkButtons;
exports.default = _default;